import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TemplatesService } from 'src/app/services/templates.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-templates-edit',
  templateUrl: './templates-edit.page.html',
  styleUrls: ['./templates-edit.page.scss'],
})
export class TemplatesEditPage implements OnInit, OnDestroy {

  updateTemplateForm: FormGroup;
  id: any;
  time;

  constructor(
    private fb: FormBuilder,
    private actRoute: ActivatedRoute,
    private router: Router,
    private templateService: TemplatesService,
    public authService: AuthenticationService,
  ) {
   }


  ngOnInit() {
    this.authService.login();
    this.time = Math.floor(Date.now()/1000);
    this.updateTemplateForm = this.fb.group({
      title: [''],
      body: [''],
      timestamp: [''],
    });



    this.id = this.actRoute.snapshot.paramMap.get('id');
    this.templateService.getTemplate(this.id).subscribe(res => {
      const a = res.payload.data();
      // console.log(a["published"]);
      this.updateTemplateForm.patchValue(a);
    });
  }

  ionViewWillEnter() {
    if (this.authService.isLoggedIn === false) {
      this.router.navigateByUrl('/admin/login');
    }
  }

  ngOnDestroy(){
    this.templateService.getTemplate(this.id).subscribe().unsubscribe();
    // console.log("leaving page");
  }

  updateTemplate() {
    const changes = this.updateTemplateForm.value;
    const update = this.templateService.updateTemplate(this.id, changes)
      .subscribe();
    update.unsubscribe();

    this.router.navigate(['admin/templates']);
  }


}
